/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvestmentDetailsModel
 */
export interface InvestmentDetailsModel {
    /**
     * 
     * @type {string}
     * @memberof InvestmentDetailsModel
     */
    investmentNumber: string;
    /**
     * 
     * @type {string}
     * @memberof InvestmentDetailsModel
     */
    investmentName: string;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsModel
     */
    investmentValue: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsModel
     */
    intermediaryFee: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsModel
     */
    previousIntermediaryFee?: number;
    /**
     * 
     * @type {Date}
     * @memberof InvestmentDetailsModel
     */
    feeRenewalDate: Date;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsModel
     */
    daysUntilDue: number;
    /**
     * 
     * @type {string}
     * @memberof InvestmentDetailsModel
     */
    renewalStatus: string;
}

/**
 * Check if a given object implements the InvestmentDetailsModel interface.
 */
export function instanceOfInvestmentDetailsModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "investmentNumber" in value;
    isInstance = isInstance && "investmentName" in value;
    isInstance = isInstance && "investmentValue" in value;
    isInstance = isInstance && "intermediaryFee" in value;
    isInstance = isInstance && "feeRenewalDate" in value;
    isInstance = isInstance && "daysUntilDue" in value;
    isInstance = isInstance && "renewalStatus" in value;

    return isInstance;
}

export function InvestmentDetailsModelFromJSON(json: any): InvestmentDetailsModel {
    return InvestmentDetailsModelFromJSONTyped(json, false);
}

export function InvestmentDetailsModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentDetailsModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'investmentNumber': json['InvestmentNumber'],
        'investmentName': json['InvestmentName'],
        'investmentValue': json['InvestmentValue'],
        'intermediaryFee': json['IntermediaryFee'],
        'previousIntermediaryFee': !exists(json, 'PreviousIntermediaryFee') ? undefined : json['PreviousIntermediaryFee'],
        'feeRenewalDate': (new Date(json['FeeRenewalDate'])),
        'daysUntilDue': json['DaysUntilDue'],
        'renewalStatus': json['RenewalStatus'],
    };
}

export function InvestmentDetailsModelToJSON(value?: InvestmentDetailsModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'InvestmentNumber': value.investmentNumber,
        'InvestmentName': value.investmentName,
        'InvestmentValue': value.investmentValue,
        'IntermediaryFee': value.intermediaryFee,
        'PreviousIntermediaryFee': value.previousIntermediaryFee,
        'FeeRenewalDate': (value.feeRenewalDate.toISOString()),
        'DaysUntilDue': value.daysUntilDue,
        'RenewalStatus': value.renewalStatus,
    };
}

